var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.page.scores,"label":"Score min.","outlined":"","hide-details":"","clearable":_vm.clearable},model:{value:(_vm.scoreMin),callback:function ($$v) {_vm.scoreMin=$$v},expression:"scoreMin"}})}
var staticRenderFns = []

export { render, staticRenderFns }